var React = require('react');

function ChevronMenuInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"expand_more_black_24dp","transform":"translate(0 24) rotate(-90)"},[React.createElement("path",{"id":"Path_409","data-name":"Path 409","d":"M0,0H24V24H0Z","fill":"none","key":0}),React.createElement("path",{"id":"Path_410","data-name":"Path 410","d":"M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z","fill":"#1a1b21","key":1})]));
}

ChevronMenuInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronMenuInline;

ChevronMenuInline.default = ChevronMenuInline;
